import { defineStore } from 'pinia';
import { projectService } from '@/services/projectService';

export const useProjectStore = defineStore('project', {
    state: () => ({
        projects: {},
        charts: {},
        partitions: {},
        currentProjectId: null
    }),

    actions: {
        async fetchProjectDetails(projectId) {
            if (this.projects[projectId]) return this.projects[projectId];

            try {
                const project = await projectService.getProjectDetails(projectId);
                this.projects[projectId] = project;
                return project;
            } catch (error) {
                console.error(`Error fetching project ${projectId}:`, error);
                throw error;
            }
        },

        async fetchCharts(projectId) {
            if (this.charts[projectId]) return this.charts[projectId];

            try {
                const charts = await projectService.getProjectCharts(projectId);
                this.charts[projectId] = charts;
                return charts;
            } catch (error) {
                console.error(`Error fetching charts for project ${projectId}:`, error);
                throw error;
            }
        },

        async fetchPartitions(projectId) {
            if (this.partitions[projectId]) return this.partitions[projectId];

            try {
                const partitions = await projectService.fetchAllPartitions(projectId);

                if (partitions.length == 0) {
                    return partitions;
                }
                const charts = await this.fetchCharts(projectId) || [];
                const chartIds = charts.map(c => c.id);

                const assignedChartIds = new Set();
                partitions.forEach(p => {
                    if (p.charts && Array.isArray(p.charts)) {
                        p.charts.forEach(id => assignedChartIds.add(id));
                    }
                });

                const unassignedChartIds = chartIds.filter(id => !assignedChartIds.has(id));

                if (unassignedChartIds.length > 0) {
                    partitions.push({
                        partitionId: 'others',
                        partitionName: 'Others',
                        partitionDescription: 'Charts not assigned to any specific partition',
                        charts: unassignedChartIds
                    });
                }

                this.partitions[projectId] = partitions;
                return partitions;
            } catch (error) {
                console.error(`Error fetching partitions for project ${projectId}:`, error);
                throw error;
            }
        },

        clearCache(projectId = null) {
            if (projectId) {
                delete this.projects[projectId];
                delete this.charts[projectId];
                delete this.partitions[projectId];
            } else {
                this.projects = {};
                this.charts = {};
                this.partitions = {};
            }
        }
    }
});
